export function comapreDates(date1,date2){
    if(date1 && !date2)return 1;
    if(!date1 && date2)return -1;

    const g1 = new Date(date1); 
    const g2 = new Date(date2); 
    if(g1.getTime() < g2.getTime()) return 1;
    else if(g1.getTime() > g2.getTime()) return -1;
    else return 0;
}